// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./local_static/templates/vai_vem/2018/assets/styles/main.scss
// module id = 475
// module chunks = 0